import { useAppRole } from "../../../common/layout/v2/useAppRole";
import { homeConfig } from "./homeConfig";
import { HomeShell } from "./HomeShell";

export const Home = () => {
  const role = useAppRole();
  return <HomeShell config={homeConfig[role]} />;
};
